export default __webpack_public_path__ + "static/media/blazepod-big.1462f6cc.svg";